module.exports = __webpack_public_path__ + "img/videoimg4.f3b4b690.jpg";